import React, { Component } from 'react';
import { setTimeout } from 'timers';
import {withRouter} from 'react-router-dom';


class Header extends Component {
    mdFormTrigger=()=> {
        if(!localStorage.getItem('token')){
            this.logout();
        }
        setTimeout(()=>{
            window.omni_md.init(); 
            window.omni_forms.init(); 
        },0);
    }
    componentDidMount(){
        this.mdFormTrigger();
    }
    logout=()=>{
        //this.props.history.push('/login');
        window.location.href=window.Basename+'/login';
        localStorage.clear();
        window.location.reload();
    }
    render() { 
        this.mdFormTrigger();  
        return ( 
            <header id="header_main">
                <div className="header_main_content">
                    <nav className="uk-navbar" style={{textAlign:'center'}}>
                        <a href="#" id="sidebar_main_toggle" className="sSwitch sSwitch_left">
                            <span className="sSwitchIcon"></span>
                        </a>
                    
                        <a href="#" id="sidebar_secondary_toggle" className="sSwitch sSwitch_right sidebar_secondary_check">
                            <span className="sSwitchIcon"></span>
                        </a>
                        <span className="header_text">{localStorage.getItem('institution_name')}</span>
                        <div className="uk-navbar-flip">
                            <div style={{marginTop: '16px',color: '#ffffff'}}>
                                <span style={{borderRight:'1px solid #fff',paddingRight:'4px'}}>{localStorage.getItem('username')}</span>
                                <span onClick={()=>this.logout()}  style={{paddingLeft:'4px',cursor:'pointer'}}>Logout</span>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        );
    }
}
 
export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Layout/Header.js